import React, { useCallback } from "react";
import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";
import { useI18n } from "i18n";
import { Trash01 as Trash01Icon } from "@remo-co/ui-core/src/icons/Trash01";
import { IEvent } from "modules/event/types";
import { addDialogNotification } from "modules/dialogNotification/redux/dialogNotificationSlice";
import { useAppDispatch } from "store/hooks";
import useEventAdmin from "../../../hooks/useEventAdmin";

interface DeleteEventButtonProps {
  eventId: IEvent["id"];
  isEditable?: boolean;
  isEventHelper?: boolean;
  className?: string;
  refetch?: () => void;
}
const DeleteEventButton = ({
  eventId,
  isEditable,
  isEventHelper,
  className,
  refetch,
}: DeleteEventButtonProps) => {
  const { t } = useI18n(["event"]);
  const dispatch = useAppDispatch();
  const { deleteEvent } = useEventAdmin();
  const handleDeleteEvent = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();

      dispatch(
        addDialogNotification({
          title: t("event:delete.event"),
          message: t("event:delete.message"),
          onConfirm: async () => {
            await deleteEvent(eventId);

            if (typeof refetch === "function") {
              refetch();
            }
          },
          confirmText: t("event:yes.delete"),
          dismissText: t("event:no.cancel"),
          confirmVariant: "secondary",
          lightDialog: true,
        }),
      );
    },

    [dispatch, t, deleteEvent, eventId, refetch],
  );
  if (!isEditable || isEventHelper) {
    return null;
  }
  return (
    <MenuItem
      className={className}
      onClick={handleDeleteEvent}
      data-testid="event-list-item-delete"
    >
      <Trash01Icon />
      {t("event:delete.this.event")}
    </MenuItem>
  );
};
export default DeleteEventButton;
